module.exports = __webpack_public_path__ + "img/c07_unitskirmisher_Normal_ua.78fca4e8.webp";